module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAALVBMVEUAAADDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8hA7x0jAAAADnRSTlMA170WHt3Mx8ExGhEPDi5w2/AAAAAvSURBVAjXY2BgMJrAwMAsp8DAsPDZBgYWuRoGBtcXFxgY9B4zQFhgMbAsWB1YBwBa9gy8cKnQfAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_prev1_hover.png
// module id = KqvN
// module chunks = 9